/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import _ from "lodash";
import { MaterialReactTable, MRT_ActionMenuItem } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Loading from "components/loading";
import { store } from "store/store";
import { useDispatch } from "react-redux";

const Example = ({ columns, data, EditarUsuario, ActivarUsuario, RestablecerContraseña }) => {
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const AdministrarUsuario = _.filter(usuarioPermisos, { idPermiso: 39 });
  const dispatch = useDispatch();

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRT_Localization_ES}
      autoResetPageIndex={false}
      initialState={{
        density: "compact",
        columnPinning: {
          left: ["mrt-row-expand", "mrt-row-select"],
          right: ["mrt-row-actions"],
        },
      }}
      paginationDisplayMode="pages"
      muiPaginationProps={{
        sx: {
          // Estilo general del componente de paginación
          "& .MuiPaginationItem-root": {
            color: "#FFFFFF", // Color de todos los números de página
          },
          "& .Mui-selected": {
            fontWeight: "bold",
            color: "#F58020", // Color del texto seleccionado
          },
        },
      }}
      muiTableHeadProps={{
        sx: { display: "table-header-group" },
      }}
      muiTableBodyCellProps={({ row, cell }) => {
        return {
          sx: {
            color: "#ffffff",
            opacity: "1",
            fontWeight: "normal",
            fontSize: 12,
          },
        };
      }}
      muiTableHeadCellProps={{
        sx: { color: "#FFFFFF", fontSize: 12 },
      }}
      icons={{
        SearchIcon: () => <Icon color="primary">search</Icon>,
        SearchOffIcon: () => <Icon color="primary">search_off</Icon>,
        CloseIcon: () => <Icon color="primary">close</Icon>,
        FullscreenIcon: () => <Icon color="primary">fullscreen</Icon>,
        FullscreenExitIcon: () => <Icon color="primary">fullscreen_exit</Icon>,
        FilterAltIcon: () => <Icon color="primary">search</Icon>,
        FilterListIcon: () => <Icon color="primary">filter_list</Icon>,
        FilterListOffIcon: () => <Icon color="primary">filter_list_off</Icon>,
        DensitySmallIcon: () => <Icon color="primary">density_small</Icon>,
        DensityMediumIcon: () => <Icon color="primary">density_medium</Icon>,
        DensityLargeIcon: () => <Icon color="primary">density_large</Icon>,
        FirstPageIcon: () => <Icon color="primary">first_page</Icon>,
        LastPageIcon: () => <Icon color="primary">last_page</Icon>,
        ChevronLeftIcon: () => <Icon color="primary">navigate_before</Icon>,
        ChevronRightIcon: () => <Icon color="primary">navigate_next</Icon>,
        MoreVertIcon: () => <Icon color="primary">more_vert</Icon>,
        MoreHorizIcon: () => <Icon color="primary">more_horiz</Icon>,
        SortIcon: () => <Icon color="primary">sort</Icon>,
        ClearAllIcon: () => <Icon color="primary">clear_all</Icon>,
        VisibilityOffIcon: () => <Icon color="primary">visibility_off</Icon>,
        ViewColumnIcon: () => <Icon color="primary">view_column</Icon>,
        SyncAltIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: (props) => {
          var icon = <Icon color="primary">arrow_downward</Icon>;
          props.className ===
          "MuiTableSortLabel-icon MuiTableSortLabel-iconDirectionAsc css-1hi7cb7-MuiTableSortLabel-icon"
            ? (icon = <Icon color="primary">arrow_upward</Icon>)
            : (icon = <Icon color="primary">arrow_downward</Icon>);

          return icon;
        },
        ArrowRightIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: () => <Icon color="primary">import_export</Icon>,
      }}
      enableExpanding={false}
      // renderDetailPanel={({ row }) => {
      //   return (
      //     <Box>
      //       {row.original?.loading ? <Loading title="Cargandooo" /> : <Box>otra cosas</Box>}
      //     </Box>
      //   );
      // }}
      enableRowActions={true}
      renderRowActionMenuItems={({ row, table, closeMenu }) => {
        const { activo } = row.original;

        if (activo) {
          return [
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="info">mode</Icon>}
              key="edit"
              label="Editar usuario"
              onClick={() => {
                EditarUsuario(row.original);
                closeMenu();
              }}
              table={table}
            />,
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="error">block</Icon>}
              key="disable"
              label="Desactivar usuario"
              onClick={() => {
                ActivarUsuario(row.original, false);
                closeMenu();
              }}
              table={table}
            />,
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="success">password</Icon>}
              key="password"
              label="Restablecer contraseña"
              onClick={() => {
                RestablecerContraseña(row.original);
                closeMenu();
              }}
              table={table}
            />,
          ];
        } else {
          return [
            <MRT_ActionMenuItem
              icon={<Icon color="success">check_circle</Icon>}
              key="enable"
              label="Activar usuario"
              onClick={() => {
                ActivarUsuario(row.original, true);
                closeMenu();
              }}
              table={table}
            />,
          ];
        }
      }}
      muiTableBodyRowProps={({ row }) => ({
        //onDoubleClick: () => VerSolicitud(row.original),
        style: { cursor: "pointer" },
      })}
    />
  );
};

export default Example;
